/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number1: NonNullable<unknown>, number2: NonNullable<unknown> }} Offer_CountdownInputs */

const en_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offer ends in ${i?.number1} d ${i?.number2} h!`)
};

const ar_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`العرض ينتهي خلال ${i?.number1} يوم ${i?.number2} ساعة!`)
};

const de_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Angebot endet in ${i?.number1} T ${i?.number2} Std.!`)
};

const es_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡La oferta termina en ${i?.number1} d ${i?.number2} h!`)
};

const fr_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'offre se termine dans ${i?.number1} j ${i?.number2} h !`)
};

const it_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'offerta termina tra ${i?.number1}g ${i?.number2}h!`)
};

const ja_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number1}日と${i?.number2}時間後に終了！`)
};

const ko_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`혜택이 ${i?.number1}일 ${i?.number2}시간 뒤에 종료돼요!`)
};

const pt_br_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta oferta termina em ${i?.number1} d ${i?.number2} h!`)
};

const ru_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предложение заканчивается через ${i?.number1} д. ${i?.number2} ч.!`)
};

const th_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ข้อเสนอจะสิ้นสุดใน ${i?.number1} วัน ${i?.number2} ชม.!`)
};

const tr_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teklif ${i?.number1} gün ${i?.number2} sa içinde sona eriyor!`)
};

const zh_cn_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`限时倒数 ${i?.number1} 天 ${i?.number2} 小时！`)
};

const zh_tw_offer_countdown = /** @type {(inputs: Offer_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`限時倒數 ${i?.number1} 天 ${i?.number2} 小時！`)
};

/**
* | output |
* | --- |
* | "Offer ends in {number1} d {number2} h!" |
*
* @param {Offer_CountdownInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const offer_countdown = /** @type {((inputs: Offer_CountdownInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offer_CountdownInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_offer_countdown(inputs)
	if (locale === "ar") return ar_offer_countdown(inputs)
	if (locale === "de") return de_offer_countdown(inputs)
	if (locale === "es") return es_offer_countdown(inputs)
	if (locale === "fr") return fr_offer_countdown(inputs)
	if (locale === "it") return it_offer_countdown(inputs)
	if (locale === "ja") return ja_offer_countdown(inputs)
	if (locale === "ko") return ko_offer_countdown(inputs)
	if (locale === "pt_br") return pt_br_offer_countdown(inputs)
	if (locale === "ru") return ru_offer_countdown(inputs)
	if (locale === "th") return th_offer_countdown(inputs)
	if (locale === "tr") return tr_offer_countdown(inputs)
	if (locale === "zh_cn") return zh_cn_offer_countdown(inputs)
	return zh_tw_offer_countdown(inputs)
});